export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Grey-1.8fa66586.jpg";